export default __webpack_public_path__ + "static/media/nouri.bd6a4028.png";